/* Yoopy – košík: darčeky zdarma, doprava zdarma, zľavový kód, upsell.
   Funguje na stránke /cart (#cart) aj vo vysúvacom košíku (#offcanvas-cart).
   Dáta: window.YoopyGift (sections/yoopy-gift.liquid). 20/10/26 */
(function () {
  "use strict";
  var D = window.YoopyGift;
  if (!D) return;
  var T = D.texts,
    ATTR = "_yoopy_gift_declined",
    MSG_KEY = "yg_coupon_msg",
    PENDING_KEY = "yg_coupon_pending",
    poolById = {},
    poolByHandle = {};
  D.pool.forEach(function (p) {
    poolById[p.id] = p;
    poolByHandle[p.handle] = p;
  });
  var busy = false,
    again = false,
    rounds = 0,
    pendingKey = null,
    state = { declined: 0, cart: null, couponMsg: null, upsellKey: null, upsellHtml: "" };
  try {
    var saved = sessionStorage.getItem(MSG_KEY);
    saved && (state.couponMsg = JSON.parse(saved));
  } catch (e) {}

  var ICON = {
    gift: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v9H5v-9"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>',
    truck: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M1 4h14v12H1z"/><path d="M15 8h4l4 4v4h-8z"/><circle cx="5.5" cy="18.5" r="2"/><circle cx="18.5" cy="18.5" r="2"/></svg>',
    check: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>',
    tag: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>',
  };

  /* ---------- Kde kreslíme: stránka košíka alebo vysúvací panel ---------- */
  function page() {
    return document.getElementById("cart");
  }
  function drawer() {
    return document.getElementById("offcanvas-cart");
  }
  function root() {
    return page() || drawer();
  }
  function isDrawer(r) {
    return !!r && r.id === "offcanvas-cart";
  }
  function listEl(r) {
    return r ? r.querySelector(".product-list") : null;
  }

  /* ---------- Pomocné ---------- */
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  var LOC = D.locale || "sk-SK",
    CUR = D.currency || "€",
    WHOLE = CUR === "Kč" || CUR === "Ft";
  // Sumy v texte: Kč/Ft zaokrúhlené nahor, € a lei s centami (19 € bez centov, 9,10 € s centami).
  function kc(cents) {
    if (WHOLE) return Math.ceil(cents / 100).toLocaleString(LOC) + "\xA0" + CUR;
    var n = Math.ceil(cents) / 100,
      d = Math.round(cents) % 100 === 0 ? 0 : 2;
    return n.toLocaleString(LOC, { minimumFractionDigits: d, maximumFractionDigits: d }) + "\xA0" + CUR;
  }
  function money(cents) {
    var d = D.decimals != null ? D.decimals : WHOLE ? 0 : 2;
    return (cents / 100).toLocaleString(LOC, { minimumFractionDigits: d, maximumFractionDigits: d }) + "\xA0" + CUR;
  }
  function clamp(pct) {
    return Math.max(2, Math.min(100, Math.round(pct)));
  }
  function fill(text, cents) {
    return esc(text).replace("[amount]", "<strong>" + kc(cents) + "</strong>");
  }
  function wait(ms) {
    return new Promise(function (r) {
      setTimeout(r, ms);
    });
  }
  function isGiftHandle(h) {
    return /^(yoopy-darek-|docapp-free-gift)/.test(h || "");
  }
  function isGift(i) {
    return (
      !!poolById[i.variant_id] ||
      !!(i.properties && i.properties._yoopy_gift) ||
      i.product_type === "YoopyGift" ||
      i.product_type === "Gift" ||
      isGiftHandle(i.handle)
    );
  }
  function tierOf(total) {
    return D.enabled ? (total >= D.t2 ? 2 : total >= D.t1 ? 1 : 0) : 0;
  }
  // Darčeky z editora témy s prioritou idú pred automatickým poolom.
  function rank(id) {
    var p = poolById[id];
    return p ? (p.prio ? 1e9 : 0) + p.qty : -1;
  }
  function post(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    });
  }
  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) {
      return r.json();
    });
  }
  function docApp() {
    var a = window.discountOnCartProApp;
    return a && typeof a.applyCode == "function" && typeof a.removeCode == "function" ? a : null;
  }
  function userCodes(cart) {
    return ((cart || state.cart || {}).discount_codes || [])
      .filter(function (d) {
        return d.applicable && !/^SD_/i.test(d.code);
      })
      .map(function (d) {
        return d.code;
      });
  }
  function shownCodes() {
    var a = docApp();
    return a && Array.isArray(a.codes)
      ? a.codes.filter(function (c) {
          return !/^SD_/i.test(c);
        })
      : userCodes();
  }
  function setCouponMsg(m) {
    state.couponMsg = m;
    try {
      m ? sessionStorage.setItem(MSG_KEY, JSON.stringify(m)) : sessionStorage.removeItem(MSG_KEY);
    } catch (e) {}
  }
  function getPending() {
    try {
      return JSON.parse(sessionStorage.getItem(PENDING_KEY) || "null");
    } catch (e) {
      return null;
    }
  }
  function setPending(p) {
    try {
      p ? sessionStorage.setItem(PENDING_KEY, JSON.stringify(p)) : sessionStorage.removeItem(PENDING_KEY);
    } catch (e) {}
  }
  function resolvePending(cart, force) {
    var p = getPending();
    if (!p) return true;
    var hit = (cart.discount_codes || []).filter(function (d) {
      return d.code.toUpperCase() === p.code;
    })[0];
    if (hit && hit.applicable) {
      setPending(null);
      setCouponMsg({ ok: true, text: T.couponOk });
      return true;
    }
    if (force || Date.now() - p.ts > 9e3) {
      setPending(null);
      setCouponMsg({ ok: false, text: T.couponBad });
      var a = docApp();
      hit && a && a.removeCode(p.code);
      return true;
    }
    return false;
  }

  // Poznámka „Daň a doprava sa vypočítajú v pokladni“ vo vysúvacom košíku (téma jej nedáva id)
  function drawerNote(r) {
    var n = r.querySelector("#yg-drawer-note");
    if (n) return n;
    var sub = r.querySelector("#offcanvas-cart-subtotal"),
      p = sub && sub.nextElementSibling;
    if (p && p.tagName === "P") {
      p.id = "yg-drawer-note";
      return p;
    }
    return null;
  }

  /* ---------- Progress bar ---------- */
  function renderPanel(r, total, hasPaid) {
    if (!r) return;
    var list = listEl(r),
      panel = r.querySelector(".yg-panel");
    if (!list || !hasPaid || (!D.enabled && !D.ship)) {
      panel && panel.remove();
      return;
    }
    if (!panel) {
      panel = document.createElement("div");
      panel.id = isDrawer(r) ? "yoopy-gift-bar-drawer" : "yoopy-gift-bar";
      list.parentNode.insertBefore(panel, list);
    }
    var marks = [];
    if (D.enabled) {
      marks.push({ at: D.t1, icon: ICON.gift });
      marks.push({ at: D.t2, icon: ICON.gift });
    }
    D.ship && marks.push({ at: D.ship, icon: ICON.truck });
    var max = Math.max.apply(
        null,
        marks.map(function (m) {
          return m.at;
        }),
      ),
      msg,
      icon;
    if (D.enabled && total < D.t1) {
      msg = fill(T.msg0, D.t1 - total);
      icon = ICON.gift;
    } else if (D.enabled && total < D.t2) {
      msg = fill(T.msg1, D.t2 - total);
      icon = ICON.gift;
    } else if (D.ship && total < D.ship) {
      msg = fill(D.enabled ? T.msg2 : T.msgShip, D.ship - total);
      icon = ICON.truck;
    } else {
      msg = esc(D.ship ? (D.enabled ? T.msgAll : T.shipDone) : T.msgGiftsDone);
      icon = ICON.check;
    }
    var done = icon === ICON.check,
      html =
        '<p class="yg-msg"><span class="yg-ico">' +
        icon +
        "</span><span>" +
        msg +
        '</span></p><div class="yg-track"><div class="yg-fill" style="width:' +
        clamp((total / max) * 100) +
        '%"></div>';
    marks.forEach(function (m) {
      html +=
        '<span class="yg-mark' + (total >= m.at ? " on" : "") + '" style="left:' + (m.at / max) * 100 + '%">' + m.icon + "</span>";
    });
    html += '</div><div class="yg-labels">';
    marks.forEach(function (m) {
      html +=
        m.at === max
          ? '<span class="yg-last">' + kc(m.at) + "</span>"
          : '<span style="left:' + (m.at / max) * 100 + '%">' + kc(m.at) + "</span>";
    });
    html += "</div>";
    if (state.declined > 0 && tierOf(total) > 0)
      html +=
        '<p class="yg-note">' +
        esc(T.declined) +
        ' <button type="button" class="yg-link" data-yg-restore>' +
        esc(T.restore) +
        "</button></p>";
    panel.className = "yg-panel" + (done ? " is-done" : "");
    panel.innerHTML = html;

    // Poznámka o doprave pod súčtom
    var note = isDrawer(r) ? drawerNote(r) : document.getElementById("taxes-shipping-at-checkout");
    if (note && D.ship) {
      note.hasAttribute("data-yg-orig") || note.setAttribute("data-yg-orig", note.innerHTML);
      note.innerHTML = total >= D.ship ? esc(T.shipDone) : note.getAttribute("data-yg-orig");
      note.classList.toggle("yg-ship-free", total >= D.ship);
    }
  }

  /* ---------- Súhrn: medzisúčet, zľavy, spolu ---------- */
  function renderTotals(r, cart) {
    if (!r || docApp()) return;
    var el = isDrawer(r) ? r.querySelector("#offcanvas-cart-subtotal") : document.getElementById("cart-subtotal");
    if (!el) return;
    var orig = 0,
      disc = {},
      order = [];
    function addDisc(title, amount) {
      if (!amount) return;
      title = title || T.discountLabel || "Zľava";
      if (!(title in disc)) {
        disc[title] = 0;
        order.push(title);
      }
      disc[title] += amount;
    }
    cart.items.forEach(function (i) {
      orig += i.original_line_price;
      (i.line_level_discount_allocations || []).forEach(function (a) {
        var app = a.discount_application || {};
        addDisc(app.title || app.key, a.amount);
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      addDisc(a.title || a.key, a.total_allocated_amount);
    });
    var html = "";
    if (order.length)
      html += '<span class="yg-tr"><span>' + esc(T.subtotalLabel || "Medzisúčet") + "</span><span>" + money(orig) + "</span></span>";
    order.forEach(function (t) {
      html +=
        '<span class="yg-tr yg-disc"><span>' + ICON.tag + esc(t) + "</span><span>−" + money(disc[t]) + "</span></span>";
    });
    html +=
      '<span class="yg-tr yg-total"><span>' +
      esc(T.totalLabel || "Spolu") +
      "</span><span>" +
      money(cart.total_price) +
      "</span></span>";
    el.className = "yg-totals" + (order.length ? "" : " is-plain");
    el.innerHTML = html;
  }

  /* ---------- Darčeky v zozname ---------- */
  function decorate(r) {
    var list = listEl(r);
    if (!list) return;
    var giftLis = [];
    list.querySelectorAll("[data-cart-line-item]").forEach(function (li) {
      var h = li.getAttribute("data-product-handle") || "";
      if (!isGiftHandle(h)) return;
      giftLis.push(li);
      var p = poolByHandle[h];
      li.classList.add("yg-line");
      var title = li.querySelector(".product-item-title");
      if (title && !title.querySelector(".yg-badge")) {
        var name = p ? p.name : title.textContent.trim();
        title.innerHTML =
          '<span class="yg-badge">' + ICON.gift + esc(T.badge) + '</span><span class="yg-name">' + esc(name) + "</span>";
      }
      var price = li.querySelector(".product-item-price");
      if (price && !price.querySelector(".yg-free"))
        price.innerHTML =
          (p && p.price ? '<s class="yg-was">' + esc(p.price) + "</s>" : "") + '<strong class="yg-free">' + esc(T.free) + "</strong>";
      var keyEl = li.querySelector("[data-line-item-key]"),
        wrap = li.querySelector(".quantity-wrapper");
      if (keyEl && wrap && !li.querySelector(".yg-remove")) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "yg-remove";
        b.setAttribute("data-yg-remove", keyEl.getAttribute("data-line-item-key"));
        b.textContent = T.remove;
        wrap.parentNode.appendChild(b);
      }
      li.querySelectorAll("a[href]").forEach(function (a) {
        a.removeAttribute("href");
      });
    });
    var head = list.querySelector(".yg-gift-head");
    if (giftLis.length) {
      if (!head) {
        head = document.createElement("li");
        head.className = "yg-gift-head";
        head.innerHTML = ICON.gift + "<span>" + esc(T.giftsHeading) + "</span>";
      }
      list.appendChild(head);
      giftLis.forEach(function (li) {
        list.appendChild(li);
      });
    } else head && head.remove();
  }

  /* ---------- Zľavový kód + Pokračovať v nákupe ---------- */
  function couponBox() {
    var box = document.createElement("div");
    box.className = "yg-coupon";
    box.innerHTML =
      '<form class="yg-coupon-form" novalidate><input type="text" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="' +
      esc(T.couponPlaceholder) +
      '" aria-label="' +
      esc(T.couponPlaceholder) +
      '"><button type="submit">' +
      esc(T.couponApply) +
      '</button></form><p class="yg-coupon-msg" role="status"></p><div class="yg-chips"></div>';
    return box;
  }
  function renderSummaryExtras(r, hasPaid) {
    if (!r) return;
    var host, before;
    var foot = null;
    if (isDrawer(r)) {
      var lst = listEl(r);
      foot = r.querySelector(".offcanvas-footer");
      if (!lst || !hasPaid) return;
      host = lst.parentNode;
      before = null;
    } else {
      host = document.querySelector("#cart-summary .card-body");
      before = host ? host.firstChild : null;
      if (!host) return;
    }
    var box = host.querySelector(".yg-coupon");
    if (!box) {
      box = couponBox();
      host.insertBefore(box, before);
    } else if (isDrawer(r) && box.nextElementSibling) host.appendChild(box);
    box.querySelector(".yg-chips").innerHTML = shownCodes()
      .map(function (c) {
        return (
          '<span class="yg-chip">' +
          ICON.tag +
          "<span>" +
          esc(String(c).toUpperCase()) +
          '</span><button type="button" data-yg-uncode="' +
          esc(c) +
          '" aria-label="' +
          esc(T.couponRemove) +
          " " +
          esc(c) +
          '">\xD7</button></span>'
        );
      })
      .join("");
    var m = box.querySelector(".yg-coupon-msg");
    m.textContent = state.couponMsg ? state.couponMsg.text : "";
    m.className = "yg-coupon-msg" + (state.couponMsg ? (state.couponMsg.ok ? " is-ok" : " is-bad") : "");
    try {
      sessionStorage.removeItem(MSG_KEY);
    } catch (e) {}
    if (foot) host = foot;
    if (T.continueText && !host.querySelector(".yg-continue")) {
      var a;
      if (isDrawer(r)) {
        a = document.createElement("button");
        a.type = "button";
        a.setAttribute("data-bs-dismiss", "offcanvas");
      } else {
        a = document.createElement("a");
        a.href = D.continueUrl || "/collections/all";
      }
      a.className = "yg-continue";
      a.textContent = T.continueText;
      var form = host.querySelector("form[action]:not(.yg-coupon-form)");
      form && form.parentNode === host ? host.insertBefore(a, form.nextSibling) : host.appendChild(a);
    }
  }

  /* ---------- Upsell ---------- */
  function norm(p) {
    var vs = p.variants || [],
      av = vs.filter(function (v) {
        return v.available;
      }),
      v0 = av[0] || vs[0] || {},
      price = typeof p.price == "number" ? p.price : Math.round(parseFloat(v0.price || 0) * 100),
      cmp = typeof p.compare_at_price == "number" ? p.compare_at_price : Math.round(parseFloat(v0.compare_at_price || 0) * 100),
      img = p.featured_image
        ? typeof p.featured_image == "string"
          ? p.featured_image
          : p.featured_image.src
        : p.images && p.images[0]
          ? p.images[0].src || p.images[0]
          : "",
      tags = Array.isArray(p.tags) ? p.tags : String(p.tags || "").split(/,\s*/);
    return {
      id: p.id,
      handle: p.handle,
      title: p.title,
      url: p.url || "/products/" + p.handle,
      price: price,
      cmp: cmp,
      img: img,
      available: av.length > 0,
      multi: vs.length > 1,
      variantId: (av[0] || {}).id,
      type: p.type || p.product_type || "",
      tags: tags,
    };
  }
  function sized(url) {
    return url ? url + (url.indexOf("?") > -1 ? "&" : "?") + "width=360" : "";
  }
  async function buildUpsell(paid) {
    var seen = {},
      out = [];
    paid.forEach(function (i) {
      seen[i.product_id] = 1;
    });
    function take(raw) {
      var p = norm(raw);
      if (
        out.length >= D.upsellCount ||
        seen[p.id] ||
        !p.available ||
        p.price <= 0 ||
        !p.variantId ||
        isGiftHandle(p.handle) ||
        p.type === "YoopyGift" ||
        p.type === "Gift" ||
        p.type === "Darek" ||
        p.type === "Darcek" ||
        p.tags.indexOf("hidden") > -1 ||
        p.tags.indexOf("__hidden") > -1 ||
        p.tags.indexOf("nocart") > -1
      )
        return;
      seen[p.id] = 1;
      out.push(p);
    }
    var src = [];
    paid.forEach(function (i) {
      src.indexOf(i.product_id) < 0 && src.push(i.product_id);
    });
    // 1) Ručne vybrané upselly produktu (metafield custom.upsell_produkty, sekcia yoopy-cart-data)
    var hs = [];
    try {
      var rd = await fetch("/cart?section_id=yoopy-cart-data");
      if (rd.ok) {
        var html = await rd.text(),
          m = html.match(/<script[^>]*id="yg-cart-data"[^>]*>([\s\S]*?)<\/script>/),
          map = m ? JSON.parse(m[1].replace(/,\s*\]/g, "]")) : {};
        paid.forEach(function (i) {
          (map[i.product_id] || []).forEach(function (h) {
            h && hs.indexOf(h) < 0 && hs.push(h);
          });
        });
      }
    } catch (e) {}
    for (var x = 0; x < hs.length && out.length < D.upsellCount; x++)
      try {
        var rh = await fetch("/products/" + encodeURIComponent(hs[x]) + ".js");
        rh.ok && take(await rh.json());
      } catch (e) {}
    // 2) Odporúčania Shopify
    for (var s = 0; s < src.length && s < 3 && out.length < D.upsellCount; s++)
      for (var k = 0; k < 2 && out.length < D.upsellCount; k++)
        try {
          var r = await fetch(
            "/recommendations/products.json?product_id=" + src[s] + "&limit=10&intent=" + (k ? "related" : "complementary"),
          );
          r.ok && ((await r.json()).products || []).forEach(take);
        } catch (e) {}
    // 3) Záložná kolekcia
    if (out.length < D.upsellCount && D.upsellFallback)
      try {
        var r2 = await fetch("/collections/" + encodeURIComponent(D.upsellFallback) + "/products.json?limit=30");
        r2.ok && ((await r2.json()).products || []).forEach(take);
      } catch (e) {}
    return out.length
      ? '<h3 class="yg-up-title">' +
          esc(T.upsellTitle) +
          '</h3><div class="yg-up-list">' +
          out
            .map(function (p) {
              return (
                '<div class="yg-up-item"><a class="yg-up-img" href="' +
                esc(p.url) +
                '"><img src="' +
                esc(sized(p.img)) +
                '" alt="' +
                esc(p.title) +
                '" loading="lazy" width="360" height="360"></a><div class="yg-up-body"><a class="yg-up-name" href="' +
                esc(p.url) +
                '">' +
                esc(p.title) +
                '</a><div class="yg-up-price">' +
                (p.multi ? esc(T.upsellFrom) + " " : "") +
                "<strong>" +
                money(p.price) +
                "</strong>" +
                (p.cmp > p.price ? " <s>" + money(p.cmp) + "</s>" : "") +
                "</div>" +
                (p.multi
                  ? '<a class="yg-up-btn" href="' + esc(p.url) + '">' + esc(T.upsellChoose) + "</a>"
                  : '<button type="button" class="yg-up-btn" data-yg-add="' + p.variantId + '">' + esc(T.upsellAdd) + "</button>") +
                "</div></div>"
              );
            })
            .join("") +
          "</div>"
      : "";
  }
  async function renderUpsell(paid) {
    var r = root(),
      list = listEl(r),
      wrap = r ? r.querySelector(".yg-upsell") : null;
    if (!list || !paid.length || !D.upsellCount) {
      wrap && wrap.remove();
      return;
    }
    var key = paid
      .map(function (i) {
        return i.product_id;
      })
      .sort()
      .join(",");
    if (key !== state.upsellKey) {
      state.upsellKey = key;
      state.upsellHtml = await buildUpsell(paid);
      if (key !== state.upsellKey) return;
    }
    r = root();
    list = listEl(r);
    wrap = r ? r.querySelector(".yg-upsell") : null;
    if (!list || !state.upsellHtml) {
      wrap && wrap.remove();
      return;
    }
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.id = isDrawer(r) ? "yg-upsell-drawer" : "yg-upsell";
      wrap.className = "yg-upsell";
      list.parentNode.insertBefore(wrap, list.nextSibling);
    }
    if (wrap.getAttribute("data-k") !== key) {
      wrap.innerHTML = state.upsellHtml;
      wrap.setAttribute("data-k", key);
    }
  }

  /* ---------- Premenovanie riadkov aplikácie Discount on Cart (ak beží) ---------- */
  var SUB = T.subtotalLabel || "Medzisúčet",
    TOT = T.totalLabel || "Spolu",
    RELABEL = { "SPOLU bez slevy": SUB, "SPOLU bez zľavy": SUB, SPOLU: SUB, CELKOM: TOT, Celkom: TOT };
  function relabel() {
    docApp() &&
      document.querySelectorAll("#cart-summary .docapp-left, #cart-summary .docapp-left strong").forEach(function (el) {
        if (!(el.tagName !== "STRONG" && el.children.length)) {
          var k = el.textContent.trim();
          RELABEL[k] && (el.textContent = RELABEL[k]);
        }
      });
  }

  /* ---------- Potvrdenie odobratia darčeka ---------- */
  function modal() {
    var m = document.getElementById("yg-modal");
    if (m) return m;
    m = document.createElement("div");
    m.id = "yg-modal";
    m.className = "yg-modal";
    m.hidden = true;
    m.setAttribute("role", "dialog");
    m.setAttribute("aria-modal", "true");
    m.setAttribute("aria-labelledby", "yg-modal-title");
    m.innerHTML =
      '<div class="yg-modal-box"><span class="yg-modal-ico">' +
      ICON.gift +
      '</span><h3 id="yg-modal-title">' +
      esc(T.modalTitle) +
      "</h3><p>" +
      esc(T.modalText) +
      '</p><div class="yg-modal-actions"><button type="button" class="yg-btn yg-btn-primary" data-yg-keep>' +
      esc(T.modalKeep) +
      '</button><button type="button" class="yg-btn yg-btn-ghost" data-yg-confirm>' +
      esc(T.modalConfirm) +
      "</button></div></div>";
    m.addEventListener("click", function (e) {
      e.target === m && closeModal();
    });
    document.body.appendChild(m);
    return m;
  }
  function openModal(key) {
    pendingKey = key;
    var m = modal();
    m.hidden = false;
    document.documentElement.classList.add("yg-lock");
    m.querySelector("[data-yg-keep]").focus();
  }
  function closeModal() {
    var m = document.getElementById("yg-modal");
    m && (m.hidden = true);
    document.documentElement.classList.remove("yg-lock");
    pendingKey = null;
  }

  /* ---------- Udalosti ---------- */
  document.addEventListener("click", async function (e) {
    var t = e.target.closest("[data-yg-remove],[data-yg-keep],[data-yg-confirm],[data-yg-restore],[data-yg-uncode],[data-yg-add]");
    if (!t) return;
    e.preventDefault();
    if (t.hasAttribute("data-yg-remove")) {
      openModal(t.getAttribute("data-yg-remove"));
      return;
    }
    if (t.hasAttribute("data-yg-keep")) {
      closeModal();
      return;
    }
    t.disabled = true;
    var attrs = {};
    if (t.hasAttribute("data-yg-confirm")) {
      var key = pendingKey;
      closeModal();
      if (!key) return;
      var u = {};
      u[key] = 0;
      attrs[ATTR] = String(state.declined + 1);
      await post("/cart/update.js", { updates: u, attributes: attrs });
    } else if (t.hasAttribute("data-yg-restore")) {
      attrs[ATTR] = String(Math.max(0, state.declined - 1));
      await post("/cart/update.js", { attributes: attrs });
    } else if (t.hasAttribute("data-yg-uncode")) {
      var code = t.getAttribute("data-yg-uncode");
      setCouponMsg(null);
      var a = docApp();
      if (a) {
        a.removeCode(code);
        await wait(2500);
      } else {
        var keep = userCodes().filter(function (c) {
          return c !== code;
        });
        await post("/cart/update.js", { discount: keep.join(",") });
      }
    } else if (t.hasAttribute("data-yg-add")) {
      t.textContent = "…";
      await post("/cart/add.js", { items: [{ id: Number(t.getAttribute("data-yg-add")), quantity: 1 }] });
    }
    rounds = 0;
    await refresh();
  });

  document.addEventListener("submit", async function (e) {
    var f = e.target.closest(".yg-coupon-form");
    if (!f) return;
    e.preventDefault();
    var input = f.querySelector("input"),
      code = (input.value || "").trim();
    if (!code) {
      input.focus();
      return;
    }
    var btn = f.querySelector("button");
    btn.disabled = true;
    var a = docApp();
    if (a) {
      setCouponMsg(null);
      setPending({ code: code.toUpperCase(), ts: Date.now() });
      a.applyCode(code);
      for (var i = 0; i < 14; i++) {
        await wait(500);
        if (resolvePending(await getCart(), false)) break;
      }
      getPending() && resolvePending(await getCart(), true);
    } else {
      var list = userCodes().filter(function (c) {
        return c.toLowerCase() !== code.toLowerCase();
      });
      list.push(code);
      await post("/cart/update.js", { discount: list.join(",") });
      var cart = await getCart(),
        hit = (cart.discount_codes || []).filter(function (d) {
          return d.code.toLowerCase() === code.toLowerCase();
        })[0];
      if (!hit || !hit.applicable) {
        setCouponMsg({ ok: false, text: T.couponBad });
        var keep = userCodes(cart).filter(function (c) {
          return c.toLowerCase() !== code.toLowerCase();
        });
        await post("/cart/update.js", { discount: keep.join(",") });
      } else setCouponMsg({ ok: true, text: T.couponOk });
    }
    btn.disabled = false;
    rounds = 0;
    await refresh();
  });

  document.addEventListener("keydown", function (e) {
    e.key === "Escape" && closeModal();
  });

  /* ---------- Otvorenie vysúvacieho košíka ---------- */
  function openDrawer() {
    var d = drawer();
    if (!d || !window.bootstrap || !bootstrap.Offcanvas) return;
    bootstrap.Offcanvas.getOrCreateInstance(d).show();
  }
  window.YoopyCartOpen = openDrawer;

  // Pridanie do košíka mimo formulára témy (napr. Yoopy upsell karty v custom.js):
  // obnoví obsah košíka a otvorí panel.
  document.addEventListener(
    "click",
    function (e) {
      var b = e.target.closest(".yoopy-upsell__btn");
      if (!b || !drawer()) return;
      setTimeout(async function () {
        if (typeof window.refreshCartContents == "function")
          await window.refreshCartContents({ ok: true, url: "", json: function () { return Promise.resolve({}); } });
        openDrawer();
      }, 1200);
    },
    true,
  );

  async function refresh() {
    typeof window.refreshCartContents == "function"
      ? await window.refreshCartContents({ ok: true, url: "", json: function () { return Promise.resolve({}); } })
      : window.location.reload();
  }

  /* ---------- Hlavná synchronizácia ---------- */
  async function sync() {
    if (busy) {
      again = true;
      return;
    }
    busy = true;
    try {
      var cart = await getCart();
      state.cart = cart;
      resolvePending(cart, false);
      var gifts = [],
        paid = [];
      cart.items.forEach(function (i) {
        (isGift(i) ? gifts : paid).push(i);
      });
      var giftSum = gifts.reduce(function (s, i) {
          return s + i.final_line_price;
        }, 0),
        total = cart.total_price - giftSum,
        tier = paid.length ? tierOf(total) : 0,
        declined = parseInt((cart.attributes || {})[ATTR], 10) || 0,
        fixAttr = null;
      if (declined > tier) {
        declined = tier;
        fixAttr = {};
        fixAttr[ATTR] = String(declined);
      }
      state.declined = declined;
      var earned = Math.max(0, tier - declined),
        r = root();
      renderPanel(r, total, paid.length > 0);
      decorate(r);
      renderSummaryExtras(r, paid.length > 0);
      renderTotals(r, cart);
      relabel();
      gifts.sort(function (a, b) {
        return rank(b.variant_id) - rank(a.variant_id);
      });
      var updates = {},
        keep = [];
      gifts.forEach(function (g) {
        var p = poolById[g.variant_id],
          dup = keep.some(function (k) {
            return k.variant_id === g.variant_id;
          });
        if (!p || !p.available || dup || keep.length >= earned) {
          updates[g.key] = 0;
          return;
        }
        g.quantity !== 1 && (updates[g.key] = 1);
        keep.push(g);
      });
      var add = [],
        need = earned - keep.length;
      if (need > 0) {
        var paidSkus = paid.map(function (i) {
          return i.sku;
        });
        add = D.pool
          .filter(function (p) {
            return (
              p.available &&
              !keep.some(function (k) {
                return k.variant_id === p.id;
              })
            );
          })
          .sort(function (a, b) {
            var ia = paidSkus.indexOf(a.sku) > -1 ? 1 : 0,
              ib = paidSkus.indexOf(b.sku) > -1 ? 1 : 0;
            return (b.prio ? 1 : 0) - (a.prio ? 1 : 0) || ia - ib || b.qty - a.qty;
          });
      }
      var changed = false;
      if (Object.keys(updates).length || fixAttr) {
        var body = {};
        if (Object.keys(updates).length) {
          body.updates = updates;
          changed = true;
        }
        fixAttr && (body.attributes = fixAttr);
        await post("/cart/update.js", body);
      }
      for (var j = 0; j < add.length && need > 0; j++) {
        var res = await post("/cart/add.js", { items: [{ id: add[j].id, quantity: 1, properties: { _yoopy_gift: "1" } }] });
        res.ok ? (need--, (changed = true)) : (add[j].available = false);
      }
      if (changed && rounds < 4) {
        rounds++;
        busy = false;
        await refresh();
        return;
      }
      rounds = 0;
      busy = false;
      renderUpsell(paid);
    } catch (e) {
      window.console && console.warn("YoopyGift", e);
      busy = false;
    }
    if (again) {
      again = false;
      sync();
    }
  }

  new MutationObserver(relabel).observe(document.body, { childList: true, subtree: true });
  window.addEventListener("updated.ecomify.cart", function () {
    sync();
  });
  document.addEventListener("shown.bs.offcanvas", function (e) {
    e.target && e.target.id === "offcanvas-cart" && sync();
  });
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", sync) : sync();
})();
